import React, {Component} from 'react';
import {gpn} from "../GPN"
import Back from "../sections/Back";
import axios from "axios";
import config from "../config";
import Field from "../sections/MUI/Field";
import InfiniteScroll from "react-infinite-scroller";
import Select from "../sections/MUI/Select";

class Payments extends Component {

    state = {
        payments: [],
        page: 1,
        hasNextPage: true,
        totalPages: null,

        search: ""
    };

    getPayments(page, search = "") {
        axios.get(`${config.api}/admin/payments?token=${config.token}&page=${page}&s=${search}`)
            .then(r => {
                const payments = r.data.result;

                this.setState({
                    payments: page > 1 ? [...this.state.payments, ...payments.docs] : payments.docs,
                    page: page + 1,
                    hasNextPage: payments.hasNextPage,
                    totalPages: payments.totalPages
                });
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    changeStatus(id, status) {
        let params = new URLSearchParams();
        params.append("id", id);
        params.append("status", status);
        axios.put(`${config.api}/admin/payment/status`, params)
            .then(r => {

            })
            .catch(err => {
                config.handleError(err)
            });
    }

    render() {
        const {payments, page, search, hasNextPage} = this.state;
        return (
            <div className="payments">
                <Back {...this.props}/>
                <div className="row justify-content-center">
                    <div className="col-md-7">
                        <Field name="search"
                               value={search}
                               label="جستجو"
                               onChange={(name, value) => {
                                   this.setState({[name]: value});
                                   this.getPayments(1, value);
                               }}/>
                    </div>

                </div>


                <br/>
                <div className="list">
                    <InfiniteScroll
                        pageStart={1}
                        loadMore={() => this.getPayments(page, search)}
                        hasMore={hasNextPage}
                        loader={<div className="loader" key={0}>دریافت ...</div>}>
                        {
                            payments ? payments?.map((p, i) =>
                                    <article key={"payment" + i}>
                                        <p><span>نحوه پرداخت:</span><span>{p.type}</span></p>
                                        <p><span>شناسه تراکنش:</span><span>{p.transid}</span></p>
                                        <p><span>کد پیگیری:</span><span>{p.tracking_number}</span></p>
                                        <p><span>شماره کارت:</span><span>{p.cardnumber}</span></p>
                                        <p><span>بانک:</span><span>{p.bank}</span></p>
                                        {p.order ?
                                            <p className="order"><span>سفارش:</span><span
                                                onClick={() => this.props.navigate(`/order/${p.order.id}`)}>{p.order.code}</span>
                                            </p>
                                            : null}

                                        <div className="status">
                                            <Select name="status"
                                                    label="وضعیت"
                                                    value={p.status}
                                                    simple
                                                    options={[
                                                        {t: "پرداخت موفق", v: "پرداخت موفق"},
                                                        {t: "پرداخت ناموفق", v: "پرداخت ناموفق"}
                                                    ]}
                                                    onChange={(name, value) => {
                                                        let mPayments = payments;
                                                        mPayments[i]["status"] = value;
                                                        this.setState({payments: mPayments});
                                                        this.changeStatus(p.id, value);
                                                    }}/>
                                        </div>
                                        <p><span>وضعیت:</span><span
                                            style={{color: p.status === "پرداخت موفق" ? "#43A047" : "#D32F2F"}}>{p.status}</span>
                                        </p>
                                        <p><span>تاریخ:</span><span>{p.createdAt}</span></p>
                                    </article>)
                                : null
                        }
                    </InfiniteScroll>
                </div>
            </div>
        );
    }
}

export default gpn(Payments);